/* Conversion parts strip on the Paddock collection page (sections/paddock-collection.liquid), 2026-10-13.
 *
 * A conversion part fits a bike only once its final drive is converted (a 520 sprocket on a bike that left the
 * factory with 525 or 530 chain). The importer writes those bikes to their own field, custom.fits_bikes_conversion,
 * so a shopper on the stock drive never lands on one. When exactly one bike is picked (the shop-by-bike picker's
 * filter.p.m.custom.fits_bikes=<gid>), this fetches the same collection filtered on the conversion field instead,
 * through the Section Rendering API, and shows its cards in [data-pc-conv] under the results.
 *
 * The bike is read from the URL, never from filter.active_values: Shopify sends at most 100 values per filter and a
 * bike outside them filters with no active value (paddock-bike-picker.js has the same rule).
 *
 * Only a response whose results carry data-pc-conv-ok (the section lists the conversion filter) is used: without the
 * Search & Discovery filter Shopify ignores the parameter and this fetch would return the whole collection. The CURRENT
 * page cannot answer that: Shopify lists a filter only when the products shown carry a value for it.
 *
 * paddock-collection.js replaces [data-pc-results] on every filter change, strip included, and fires `pc:rendered`.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-pc]');
  if (!root) return;

  var BIKE = 'filter.p.m.custom.fits_bikes';
  var STOCK = 'filter.v.availability';
  var controller = null;

  function cardKey(li) {
    var a = li.querySelector('a[href*="/products/"]');
    return a ? new URL(a.getAttribute('href'), window.location.origin).pathname : null;
  }

  function fill() {
    var strip = root.querySelector('[data-pc-conv]');
    if (!strip) return;
    if (controller) controller.abort();

    var here = new URLSearchParams(window.location.search);
    var bikes = here.getAll(BIKE);
    if (bikes.length !== 1) return;

    var form = root.querySelector('[data-pc-form]');
    var params = new URLSearchParams();
    params.set(strip.getAttribute('data-param'), bikes[0]);
    // "In stock only" carries over; every other filter describes the stock-fit results, not these.
    here.getAll(STOCK).forEach(function (v) { params.append(STOCK, v); });
    if (here.get('sort_by')) params.set('sort_by', here.get('sort_by'));
    var pageUrl = form.getAttribute('action') + '?' + params.toString();

    var fetchUrl = new URL(pageUrl, window.location.origin);
    fetchUrl.searchParams.set('section_id', root.getAttribute('data-section-id'));

    controller = new AbortController();
    fetch(fetchUrl.toString(), { signal: controller.signal, credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // The strip may have been replaced while this was in flight.
        if (!document.contains(strip)) return;
        if (!doc.querySelector('[data-pc-results][data-pc-conv-ok]')) return;

        // A part already in the stock-fit results is not repeated here.
        var shown = {};
        root.querySelectorAll('[data-pc-grid] > li').forEach(function (li) {
          var k = cardKey(li);
          if (k) shown[k] = true;
        });

        var grid = strip.querySelector('[data-pc-conv-grid]');
        var added = 0;
        doc.querySelectorAll('[data-pc-grid] > li').forEach(function (li) {
          var k = cardKey(li);
          if (k && shown[k]) return;
          grid.appendChild(document.importNode(li, true));
          added++;
        });
        if (!added) return;

        // More than one page of conversion parts: link to the filtered collection itself.
        var all = strip.querySelector('[data-pc-conv-all]');
        if (all && doc.querySelector('[data-pc-next]')) {
          all.href = pageUrl;
          all.hidden = false;
        }
        strip.hidden = false;
      })
      .catch(function () { /* The strip is an extra; on any failure it simply stays hidden. */ });
  }

  root.addEventListener('pc:rendered', fill);
  fill();
})();
